export const APP_SHELL = {
  app: 'app',
  noChrome: 'no-chrome',
  auth: 'auth',
  extensionAuth: 'extension-auth',
  public: 'public',
} as const

export type AppShell = (typeof APP_SHELL)[keyof typeof APP_SHELL]

export const DEFAULT_APP_SHELL: AppShell = APP_SHELL.app

export const resolveAppShell = (appShell?: AppShell | null): AppShell =>
  appShell ?? DEFAULT_APP_SHELL
